import React from 'react';
import axios from 'axios';
import { Loading, ToastNotification } from 'carbon-components-react';
import { t, l } from '../../RI18n';
import './style.css';

class ImportStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      importStatus: [],
    };
  }

  componentDidMount() {
    axios
      .get('/sam/todo_list/import_status.json')
      .then((result) => {
        this.setState({
          isLoaded: true,
          importStatus: result.data,
        });
      })
      .catch(() => {
        this.setState({
          isLoaded: true,
          error: true,
        });
      });
  }

  formatImportTime = (importTimeString) => {
    if (importTimeString !== null) {
      return l('time.formats.default', importTimeString);
    }
    return '';
  };

  render() {
    const { error, isLoaded, importStatus } = this.state;

    if (importStatus.to_display === false) {
      return null;
    }

    if (error) {
      console.log(t('todolist.import_status.error'));
      return null;
    } if (!isLoaded) {
      return (
        <span>
          <br />
          <Loading small withOverlay={false} />
        </span>
      );
    }
    if (importStatus.last_status === 'failed') {
      if (this.props.notify) {
        this.props.updateToDos();
      }

      const renderedReportStatusText = t('widget.status.error');

      const lastImportTime = this.formatImportTime(
        importStatus.last_import_time,
      );
      const lastSuccessTime = this.formatImportTime(
        importStatus.last_success_time,
      );

      const caption = importStatus.is_admin === true
        ? t('todolist.import_status.caption_admin')
        : t('todolist.import_status.caption_not_admin');
      const details = importStatus.is_admin === true ? (
        <span
          dangerouslySetInnerHTML={{
            __html: t('todolist.import_status.details'),
          }}
        />
      ) : (
        ''
      );
      const titleText = importStatus.is_admin === true
        ? t('todolist.import_status.title_admin')
        : t('todolist.import_status.title_not_admin');

      const titleTextWithTooltip = <span className="notification_text" title={renderedReportStatusText}>{titleText}</span>;

      let subtitleText;

      if (lastSuccessTime === null || lastSuccessTime === '') {
        subtitleText = (
          <span className="notification_text">
            <span>
              {t('todolist.import_status.failed_on', {
                last_import_time: lastImportTime,
              })}
            </span>
          </span>
        );
      } else {
        subtitleText = (
          <span className="notification_text">
            <span>
              {t('todolist.import_status.failed_on', {
                last_import_time: lastImportTime,
              })}
            </span>
            <br />
            <span>
              {t('todolist.import_status.success_on', {
                last_success_time: lastSuccessTime,
              })}
            </span>
          </span>
        );
      }

      const captionText = (
        <span className="notification_text">
          <span>{caption}</span>
          <br />
          {details}
        </span>
      );

      return (
        <ToastNotification
          className="notification_style"
          title={titleTextWithTooltip}
          subtitle={subtitleText}
          caption={captionText}
          hideCloseButton
          aria-label={t('todolist.aria_label', { name: t('todolist.import_status.name'), status: renderedReportStatusText })}
          role="region"
        />
      );
    }
    return null;
  }
}

export default ImportStatus;
